// extracted by mini-css-extract-plugin
export default {"wrapper":"SideBar_wrapper__Er4OR","avatar":"SideBar_avatar__mEn9l","btn":"SideBar_btn__1j063"};